module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_shikan-878b20b07bdf661e1acd7be6c433a283.png";